import axios from 'axios'
import React, { useEffect, useState } from 'react'
import apiClient from '../../../utils/apiclient'
import { useNavigate } from 'react-router-dom'

const Restaurantdata = (route) => {
  const navigate=useNavigate()
   const [data,Setdata]=useState([])

   const [id,SetId]=useState([])
   const [isedit,SetIsEdit]=useState(false)
     const [value, setValue] = useState("");
 const [editData, setEditData] = useState({
  distance: "",
  isRiderFromBentoBox: false,
  isPackagingFromBentoBox: false,
  price: "",
  LTMOV: 0,
  MTMOV: 0,
  discounted: false,
  discount: 0,
});
const updateDistance = async (
  id,
  distance,
  isRiderFromBentoBox,
  isPackagingFromBentoBox,
  price,
  LTMOV,
  MTMOV,
  discounted,
  discount
) => {
  try {
    const response = await apiClient.put(
      `/restaurant/updateMaximumDistance/${id}/${Number(distance)}/${Boolean(isRiderFromBentoBox)}/${Boolean(isPackagingFromBentoBox)}/${Number(price)}/${Number(LTMOV)}/${Number(MTMOV)}/${Boolean(discounted)}/${Number(discount)}`
    );

    if (response.status === 200 || response.status === 204) {
      const result = await apiClient.get(`${route.route}`);
      Setdata(result.data);
    }
  } catch (e) {
    console.error(e);
  }

  SetIsEdit(false);
};
  useEffect(()=>{
      const tableData=async()=>{
        try{
          const data=await apiClient.get( `${route.route}`);
          console.log(data.data);
          Setdata(data.data);
          
        }
        catch(e){
          console.error(e); 
        }
  
      }
tableData()    },[])
    return (
    <div className="w-full flex-1 flex flex-col min-h-0">
      <div className="flex justify-between items-center mb-2 flex-shrink-0 gap-3">
        <h2 className="text-base md:text-xl font-semibold text-gray-800 whitespace-nowrap">All Restaurants</h2>
      </div>
<div className="w-full flex-1 overflow-auto pb-4 relative">
        <table className='min-w-max w-full bg-white shadow-md border-collapse'>
          <thead className="bg-gray-800 text-white sticky top-0 z-20 shadow-md">
            <tr>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center">Restaurant Id</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center">Restaurant Name</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center">Maximum distance</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center">Packaging from BentoBox</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center">Rider from BentoBox</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center">Minimum Order Value</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center">LTMOV</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center">MTMOV</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center">Discount</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center">Discounted</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
        {
          data.map((data,index)=>(
        
            <tr key={index} className='border-b border-gray-300 hover:bg-gray-50 transition'>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center text-gray-800">{data.id}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center text-blue-600 hover:text-blue-900 hover:underline cursor-pointer" onClick={()=>navigate(`/restaurant/${data.id}`)}>{data.name}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center text-gray-800">{data.maximumdistance} </td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center text-gray-800">{data.packagingFromBentoBox?"Yes":"No"}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center text-gray-800">{data.riderFromBentoBox?"Yes":"No"}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center text-gray-800">{data.minimumOrderValue} </td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center text-gray-800">{data.LTMOV ?? 0}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center text-gray-800">{data.MTMOV ?? 0}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center text-gray-800">{data.discount ?? 0}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center text-gray-800">{data.discounted ? "Yes" : "No"}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center text-gray-800">
                <div className="flex items-center justify-center gap-2">
                  <button
                    className="bg-blue-500 hover:bg-blue-600 text-white rounded transition px-3 py-1 font-medium text-[10px] md:text-sm"
                    onClick={() => {
                      SetId(data.id);
                      SetIsEdit(!isedit);
                      setEditData({
                        distance: data.maximumdistance,
                        isRiderFromBentoBox: data.riderFromBentoBox,
                        isPackagingFromBentoBox: data.packagingFromBentoBox,
                        price: data.minimumOrderValue,
                        LTMOV: data.LTMOV ?? 0,
                        MTMOV: data.MTMOV ?? 0,
                        discounted: data.discounted ?? false,
                        discount: data.discount ?? 0,
                      });
                    }}
                  >
                    Edit
                  </button>

                  <button
                    className="bg-green-500 hover:bg-green-600 text-white rounded transition px-3 py-1 font-medium text-[10px] md:text-sm"
                    onClick={() => navigate(`/restaurant/${data.id}/delivery-zones`)}
                  >
                    Zones
                  </button>

                  {id === data.id && isedit && (
                    <div className="flex items-center gap-2 ml-2 bg-gray-100 p-2 rounded shadow-inner">
                      <div className="flex items-center gap-1">
                        <span className="text-[10px] md:text-xs font-medium text-gray-700">Max Dist:</span>
                        <input
                          type="number"
                          value={editData.distance}
                          onChange={(e) =>
                            setEditData({
                              ...editData,
                              distance: e.target.value,
                            })
                          }
                          className="border px-2 py-1 rounded w-16"
                          placeholder="Dist"
                        />
                      </div>

                      <label className="flex items-center gap-1 text-[10px] md:text-xs font-medium">
                        <input
                          type="checkbox"
                          checked={editData.isRiderFromBentoBox}
                          onChange={(e) =>
                            setEditData({
                              ...editData,
                              isRiderFromBentoBox: e.target.checked,
                            })
                          }
                        />
                        Rider
                      </label>

                      <label className="flex items-center gap-1 text-[10px] md:text-xs font-medium">
                        <input
                          type="checkbox"
                          checked={editData.isPackagingFromBentoBox}
                          onChange={(e) =>
                            setEditData({
                              ...editData,
                              isPackagingFromBentoBox: e.target.checked,
                            })
                          }
                        />
                        Pkg
                      </label>

                      <div className="flex items-center gap-2 bg-gray-100 p-2 rounded shadow-inner">
                        <span className="text-[10px] md:text-xs font-medium text-gray-700">Price:</span>
                        <input
                          type="number"
                          value={editData.price}
                          onChange={(e) =>
                            setEditData({
                              ...editData,
                              price: e.target.value,
                            })
                          }
                          className="border px-2 py-1 rounded w-16"
                          placeholder="Price"
                        />
                      </div>

                      <div className="flex items-center gap-2 bg-gray-100 p-2 rounded shadow-inner">
                        <div className="flex items-center gap-1">
                          <span className="text-[10px] md:text-xs font-medium text-gray-700">LTMOV:</span>
                          <input
                            type="number"
                            value={editData.LTMOV}
                            onChange={(e) =>
                              setEditData({
                                ...editData,
                                LTMOV: Number(e.target.value),
                              })
                            }
                            className="border px-2 py-1 rounded w-16"
                            placeholder="LTMOV"
                          />
                        </div> 
                        <div className="flex items-center gap-1">
                          <span className="text-[10px] md:text-xs font-medium text-gray-700">MTMOV:</span>
                          <input
                            type="number"
                            value={editData.MTMOV}
                            onChange={(e) =>
                              setEditData({
                                ...editData,
                                MTMOV: Number(e.target.value),
                              })
                            }
                            className="border px-2 py-1 rounded w-16"
                            placeholder="MTMOV"
                          />
                        </div>
                      </div>

                      <div className="flex items-center gap-2 bg-gray-100 p-2 rounded shadow-inner">
                         <label className="flex items-center gap-1 text-[10px] md:text-xs font-medium">
                          <input
                            type="checkbox"
                            checked={editData.discounted}
                            onChange={(e) =>
                              setEditData({
                                ...editData,
                                discounted: e.target.checked,
                              })
                            }
                          />
                          Discounted
                        </label>
                        <div className="flex items-center gap-1">
                          <span className="text-[10px] md:text-xs font-medium text-gray-700">Discount:</span>
                          <input
                            type="number"
                            value={editData.discount}
                            onChange={(e) =>
                              setEditData({
                                ...editData,
                                discount: Number(e.target.value),
                              })
                            }
                            className="border px-2 py-1 rounded w-16"
                            placeholder="Discount"
                          />
                        </div>
                      </div>

                      <button
                        className="bg-green-600 hover:bg-green-700 text-white rounded transition px-3 py-1 font-medium text-[10px] md:text-sm"
                        onClick={() =>
                          updateDistance(
                            data.id,
                            editData.distance,
                            editData.isRiderFromBentoBox,
                            editData.isPackagingFromBentoBox,
                            editData.price,
                            editData.LTMOV,
                            editData.MTMOV,
                            editData.discounted,
                            editData.discount
                          )
                        }
                      >
                        Save
                      </button>
                    </div>
                  )}
                </div>
              </td>
            </tr>
          ))
        }
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default Restaurantdata